export default "__VITE_ASSET__BsTL0XYN__"